import React from 'react';
import { Input, Button } from 'components';
import { Globals } from 'utils';
import { connect } from 'react-redux';
import { RouteComponentProps } from 'react-router';
import { AuthService } from 'services';
import { RootState } from 'reducers';
import { Logo, BgLogin, LoginSlogan } from 'assets/img';
import { PasswordActive, PasswordInactive } from 'assets/icons';

interface Props extends RootState, RouteComponentProps {
	dispatch: any
}

class Login extends React.Component<Props> {

	state = {
		form: {
			email: '',
			password: ''
		},
		activePassword: false
	}

	componentDidMount() {
		if (this.props.user) {
			this.props.history.replace('/');
		}

		this.props.dispatch({
			type: 'SET_HEADER',
			payload: {
				title: 'Iniciar Sesión',
				onBack: null
			}
		});
	}

	submit = async (e: any) => {
		e.preventDefault();
		if (!this.state.form.email) {
			Globals.showError("Debe ingresar el correo electrónico");
			return;
		}
		if (!this.state.form.password) {
			Globals.showError("Debe ingresar la contraseña");
			return;
		}
		try {
			const res: any = await AuthService.login(this.state.form);
			await this.props.dispatch({
				type: 'SET_USER',
				payload: res.user
			});
			this.props.history.replace('/');

		} catch (error: any) {
			Globals.showError(error?.response?.data?.error);
		}
	}

	change = (e: any) => {
		this.setState({
			form: {
				...this.state.form,
				[e.target.name]: e.target.value
			}
		});
	}

	render() {
		return (
			<div id="login">
				<div className="container-black">
					<div className="row container-form container-bg" style={{ backgroundImage: `url(${ BgLogin })` }}>
						<div className="form-wrapper col-12 col-lg-6">
							<form onSubmit={ this.submit }>
								<div className="container-logo text-center">
									<img src={ Logo } alt="Logo" />
								</div>

								<p className="welcome-1">Bienvenido</p>
								<p className="welcome-2">Inicia tu sesión</p>

								<div className="container-input">
									<div className="input-group">
										<Input
											label="Correo"
											placeholder="Escribe tu correo"
											name="email"
											onChange={ this.change }
										/>
									</div>
									<div className="input-group">
										<Input
											label="Contraseña"
											placeholder="Escribe tu contraseña"
											type={ this.state.activePassword ? 'text' : 'password' }
											name="password"
											onChange={ this.change }
										/>
										<div
											className="input-group-prepend password-view"
											onClick={ () => this.setState({ activePassword: !this.state.activePassword }) }
										>
											<img src={ this.state.activePassword ? PasswordActive : PasswordInactive } alt="Show/Hide Password" />
										</div>
									</div>
									<div className="text-center">
										<Button type="submit">Iniciar Sesión</Button>
									</div>
									{/* <div className="row">
										<div className="col-md-12 text-center">
											<div className="recover">
												<Link to="/recover">Recuperar contraseña</Link>
											</div>
										</div>
									</div> */}
								</div>
							</form>
						</div>
						<div className="slogan col-lg-6">
							<img src={ LoginSlogan } alt="Login Background" />
							<p>Confía tu salud en</p>
							<p>NUESTRAS MANOS</p>
						</div>
					</div>
				</div>
			</div>
		)
	}
}

export default connect((state: RootState) => ({
	user: state.user
}))(Login);